<template>
    <div class="common-page">
        <div class="full-banner">
            <div class="wrapper">
                <h1>Quem Somos</h1>
            </div>
        </div>
        <div class="wrapper about" style="padding-bottom: 40px; padding-top: 40px">
            <p><strong>Vacuum Center</strong> é mais que um centro de soluções para Vacuum Forming, somos uma empresa que se preocupa com a sua!</p>
            <p>Estamos desde 1989 de portas abertas para receber suas idéias e seus projetos, para desenvolvermos equipamentos que atendam todas as exigências e necessidades de sua empresa.<br>Assim a Vacuum Center busca selar parcerias, aumentando cada vez mais sua produção e nosso conceito em atender bem.</p> 
            <p><strong>Vacuum Center, há {{ $moment().format('YYYY') - 1989 }} anos moldando confiança!</strong></p>
        </div>
        <get-in-touch></get-in-touch>
    </div>
</template>
<script>
import GetInTouch from '../components/GetInTouch.vue'

export default {
    name: "About",
    components: {
        GetInTouch
    }
}
</script>
<style>
.about p{
    line-height: 1.25em !important; 
    font-size: 18px !important;
}
</style>